import { Component, OnInit } from '@angular/core'; // Asegúrate de importar OnInit
import { Router } from '@angular/router';
import { WalletService } from 'src/services/wallet.service';

@Component({
  selector: 'app-login-wallet',
  templateUrl: './login-wallet.component.html',
  styleUrls: ['./login-wallet.component.scss']
})
export class LoginWalletComponent implements OnInit {
  loginData = { email: '', password: '', confirmPassword: '', code: '' };
  step: 'email' | 'password' | 'set_password' | 'verification' = 'email';
  loading = false;
  errorMessage = '';

  constructor(private walletService: WalletService, private router: Router) { }

  ngOnInit(): void {
    // CORRECCIÓN: Si el usuario ya tiene sesión activa, mándalo al dashboard automáticamente
    const token = localStorage.getItem('auth_token');
    if (token) {
      this.router.navigate(['/dashboard-wallet']);
    }
  }

  onNextStep(form: any) {
    if (form.invalid) return;
    this.loading = true;
    this.errorMessage = '';
    
    if (this.step === 'email') this.handleEmail();
    else if (this.step === 'password') this.handlePassword();
    else if (this.step === 'set_password') this.handleSetPassword();
    else if (this.step === 'verification') this.handleVerify();
  }

  private handleEmail() {
    this.walletService.checkEmail(this.loginData.email).subscribe(
      (res: any) => { 
        this.loading = false; 
        this.step = res.hasPassword ? 'password' : 'set_password'; 
      },
      (err: any) => { 
        this.loading = false; 
        this.errorMessage = 'El correo electrónico no está registrado.'; 
      }
    );
  }

  private handlePassword() {
    this.walletService.verifyPassword(this.loginData.email, this.loginData.password).subscribe(
      (res: any) => {
        this.loading = false;
        if (res.token) {
          localStorage.setItem('auth_token', res.token);
          this.router.navigate(['/dashboard-wallet']);
        }
      },
      (err: any) => { 
        this.loading = false; 
        this.errorMessage = 'Contraseña incorrecta.'; 
      }
    );
  }

  private handleSetPassword() {
    if (this.loginData.password !== this.loginData.confirmPassword) { 
      this.errorMessage = 'Las contraseñas no coinciden.'; 
      this.loading = false; 
      return; 
    }

    this.walletService.createPassword(this.loginData.email, this.loginData.password).subscribe(
      (res: any) => { 
        // Después de crear pass, el backend mandó el correo. Vamos a verificar.
        this.step = 'verification'; 
        this.loading = false; 
      },
      (err: any) => { 
        this.loading = false; 
        this.errorMessage = 'Error al guardar la contraseña.'; 
      }
    );
  }

  private handleVerify() {
    this.walletService.verifyCode(this.loginData.email, this.loginData.code).subscribe(
      (res: any) => { 
        this.loading = false; 
        if (res.token) {
          localStorage.setItem('auth_token', res.token);
          this.router.navigate(['/dashboard-wallet']); 
        }
      },
      (err: any) => { 
        this.loading = false; 
        this.errorMessage = 'Código inválido o expirado (máximo 5 min).'; 
      }
    );
  }

  goBack() { 
    this.errorMessage = '';
    this.step = 'email'; 
  }
}